import EntityTagsSection from "@via/components/entity-tags-section.tsx";
import { useFamilyTagAccess } from "@via/hooks/useFamilyTagAccess.ts";
import { TaggableEntityType } from "common";
import { type JSX } from "react";

/**
 * The tags of a process family, editable when the catalog grants tag rights for that family.
 *
 * A separate component so the catalog is fetched only where tags are shown: the process form
 * mounts for new drafts and for AI models and model skills too, and none of those show tags.
 */
export default function ProcessTagsSection({
  processGid,
}: {
  processGid: number;
}): JSX.Element {
  const canEditTags = useFamilyTagAccess(processGid);
  return (
    <EntityTagsSection
      entityType={TaggableEntityType.Process}
      entityId={String(processGid)}
      canEdit={canEditTags}
    />
  );
}
